import React from 'react'
import Person from '../icons/Person'
import { Link } from 'react-router-dom'

interface Props {
  name: string
  date: string
  lessonId: number
}

const LessonItem = ({ name, date, lessonId }: Props) => {
  return (
    <Link
      to={`/lesson/${lessonId}`}
      className="flex-1 bg-[#DBEAFE] rounded-md flex justify-between items-center cursor-pointer p-4">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 text-slateGray">
          <Person />
        </div>
        <div className="text-18 font-sans text-slateGray font-semibold">{name}</div>
      </div>
      <div className="text-18 font-sans text-slateGray">{date}</div>
    </Link>
  )
}

export default LessonItem
